import { createSlice } from '@reduxjs/toolkit';
import { getAllDigitalUnits } from 'api/digital-units';
import { dispatch } from '../index';
import { store } from 'store';

const initialState = {
    list: [],
    total: 0,
    currentPage: 1,
    rowsPerPage: 10,
    isLoading: false,
    searchQuery: '',
    sorting: {
        field: 'updatedAt',
        value: -1
    },
    filters: {
        unitCode: '',
        title: '',
        lastUpdated: { startDate: null, endDate: null }
    }
};

const slice = createSlice({
    name: 'digitalUnits',
    initialState,
    reducers: {
        setDigitalUnitsList(state, action) {
            state.list = action.payload.data;
            state.total = action.payload.total;
            state.isLoading = false;
        },
        setCurrentPage(state, action) {
            state.currentPage = action.payload;
        },
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        },
        setSearchQuery(state, action) {
            state.currentPage = 1;
            state.searchQuery = action.payload;
        },
        setSorting(state, action) {
            state.currentPage = 1;
            state.sorting = action.payload;
        },
        setFilters(state, action) {
            state.currentPage = 1;
            state.filters = action.payload;
        }
    }
});

export default slice.reducer;

export function initialLoadDigitalUnits() {
    return async () => {
        await getListDigitalUnits();
    };
}

export function digitalUnitsCurrentPage(val) {
    return async () => {
        await dispatch(slice.actions.setCurrentPage(val));
        await getListDigitalUnits();
    };
}

export function digitalUnitsRowsPerPage(val) {
    return async () => {
        dispatch(slice.actions.setRowsPerPage(val));
    };
}

export function setDigitalUnitsSorting(val) {
    return async () => {
        dispatch(slice.actions.setSorting(val));
        await getListDigitalUnits();
    };
}

export function searchDigitalUnits(query) {
    return async () => {
        dispatch(slice.actions.setSearchQuery(query));
        await getListDigitalUnits();
    };
}

export function applyAdvancedFiltering(filters) {
    return async () => {
        dispatch(slice.actions.setFilters(filters));
        await getListDigitalUnits();
    };
}

async function getListDigitalUnits() {
    try {
        dispatch(slice.actions.setLoading(true));
        const storeData = store.getState();
        const { currentPage, sorting, rowsPerPage, searchQuery, filters } = storeData.digitalUnits;

        const units = await getAllDigitalUnits({
            perPage: rowsPerPage,
            pageNo: currentPage,
            query: searchQuery,
            sortField: sorting?.field,
            sorting: sorting?.value,
            unitcode: filters?.unitcode || '',
            title: filters?.title || '',
            startDate: filters?.lastUpdated?.startDate || '',
            endDate: filters?.lastUpdated?.endDate || ''
        });
        dispatch(slice.actions.setDigitalUnitsList(units?.data));
    } catch (err) {
        console.log(err);
        dispatch(slice.actions.setLoading(false));
        throw new Error(err.message);
    }
}
